import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";

var _hoisted_1 = /*#__PURE__*/_createTextVNode("Cancel");

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Confirm");

import { reactive, computed } from "vue";
import { DateTime } from "luxon";
import { useMessage } from "naive-ui";
import { UseTimeAgo } from "@vueuse/components";
import { useUserStore } from "@/store/user";
import { useIsMobile } from "@/utils/reactive";
import { handleError } from "@/utils/errors";
import UsersList from "@/components/users/UsersList.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    members: {
      default: function _default() {
        return [];
      }
    },
    groupId: null,
    loader: null,
    removeLabel: {
      default: "Remove"
    },
    confirmationText: {
      default: "Are you sure you want to remove this user?"
    },
    owner: null,
    error: null
  },
  emits: ["retry", "unlink"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var messageAPI = useMessage();
    var userStore = useUserStore();
    var isMobile = useIsMobile();
    var showUnlinkConfirm = reactive({});
    var isOwner = computed(function () {
      var _props$owner, _userStore$user;

      return userStore.authenticated && ((_props$owner = props.owner) === null || _props$owner === void 0 ? void 0 : _props$owner.id) === ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.id);
    });

    var unlink = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                showUnlinkConfirm[user.id] = false;
                _context.prev = 1;
                _context.next = 4;
                return http.delete("/groups/".concat(props.groupId, "/users"), {
                  data: {
                    usersIds: [user.id]
                  }
                });

              case 4:
                emit("unlink", user);
                messageAPI.success("The user \"".concat(user.userName, "\" has been removed"));
                _context.next = 15;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                _context.t1 = messageAPI;
                _context.next = 13;
                return handleError(_context.t0, {
                  placeholder: "There was an error during the removing process"
                });

              case 13:
                _context.t2 = _context.sent;

                _context.t1.error.call(_context.t1, _context.t2);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function unlink(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _props$owner2;

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_popconfirm = _resolveComponent("n-popconfirm");

      return _openBlock(), _createBlock(UsersList, {
        users: __props.members,
        ownerId: (_props$owner2 = __props.owner) === null || _props$owner2 === void 0 ? void 0 : _props$owner2.id,
        loader: __props.loader,
        error: __props.error,
        onRetry: _cache[0] || (_cache[0] = function ($event) {
          return emit('retry');
        })
      }, {
        notice: _withCtx(function (_ref3) {
          var user = _ref3.user;
          return [_createVNode(_unref(UseTimeAgo), {
            time: _unref(DateTime).fromISO(user.addedDate, {
              zone: 'UTC'
            }).toJSDate()
          }, {
            default: _withCtx(function (_ref4) {
              var timeAgo = _ref4.timeAgo;
              return [_renderSlot(_ctx.$slots, "time", {
                time: timeAgo
              }, function () {
                return [_createTextVNode(" Joined " + _toDisplayString(timeAgo), 1)];
              })];
            }),
            _: 2
          }, 1032, ["time"])];
        }),
        actions: _withCtx(function (_ref5) {
          var _unref$user;

          var user = _ref5.user;
          return [_unref(isOwner) && ((_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.id) !== user.id ? (_openBlock(), _createBlock(_component_n_popconfirm, {
            key: 0,
            "show-icon": false,
            show: _unref(showUnlinkConfirm)[user.id],
            placement: _unref(isMobile) ? 'top' : 'left',
            onClickoutside: function onClickoutside($event) {
              return _unref(showUnlinkConfirm)[user.id] = false;
            },
            onPositiveClick: function onPositiveClick($event) {
              return unlink(user);
            }
          }, {
            activator: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                type: "error",
                onClick: function onClick($event) {
                  return _unref(showUnlinkConfirm)[user.id] = true;
                }
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(__props.removeLabel), 1)];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            action: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                size: "small",
                onClick: function onClick($event) {
                  return _unref(showUnlinkConfirm)[user.id] = false;
                }
              }, {
                default: _withCtx(function () {
                  return [_hoisted_1];
                }),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_n_button, {
                size: "small",
                type: "warning",
                onClick: function onClick($event) {
                  return unlink(user);
                }
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            default: _withCtx(function () {
              return [_createTextVNode(" " + _toDisplayString(__props.confirmationText), 1)];
            }),
            _: 2
          }, 1032, ["show", "placement", "onClickoutside", "onPositiveClick"])) : _createCommentVNode("", true)];
        }),
        _: 3
      }, 8, ["users", "ownerId", "loader", "error"]);
    };
  }
});